export const DATA = {
  "Skill level": "Beginner",
  "Time to complete": "Approx. 60 hours",
  Certificate: "Included",
  Prerequesties: "Python",
  description: "Machine Learning With Python",
  about:
    "Designed for learners eager to explore the world of data and AI, this course provides a solid foundation on data analysis, visualization, and core concepts of machine learning. Through hands-on projects, you'll gain skills needed to grow into real-world data scientist.",
  skills: [
    "Statistics & Linear Algebra",
    "Predictive Modeling",
    "Deploying ML Application",
  ],
  reviews: {
    1: {
      name: "Mason Rivera",
      review:
        "This course gave me a strong and clear introduction to Data Science. The instructor explained every concept step-by-step, especially data cleaning and analysis. I walked away feeling confident enough to explore more advanced topics.",
    },
    2: {
      name: "Aarushi Menon",
      review:
        "A very well-designed beginner course. I appreciated the real datasets used throughout the lessons. They made the learning experience feel practical and industry-relevant.",
    },
    3: {
      name: "Caleb Turner",
      review:
        "The course made Data Science approachable. The explanation of statistics and visualizations was simple and engaging. Perfect for anyone starting the journey.",
    },
    4: {
      name: "Janelle Brooks",
      review:
        "I loved how everything was broken down into easy-to-understand modules. This course helped me understand the fundamentals without feeling overwhelmed.",
    },
    5: {
      name: "Imran Sheikh",
      review:
        "Very beginner-friendly. The hands-on exercises taught me how to work with data efficiently. The instructor’s examples were extremely clear and practical.",
    },
    6: {
      name: "Clara Hopkins",
      review:
        "Excellent introduction to Data Science concepts. The lessons were structured nicely, and I learned how to analyze and visualize data confidently.",
    },
    7: {
      name: "Noah Patel",
      review:
        "Great course for building a foundation. I especially enjoyed the modules on exploratory data analysis and basic statistics.",
    },
    8: {
      name: "Sienna Wallace",
      review:
        "The instructor explained everything in a way that even beginners could understand. The projects at the end were super helpful in testing what I learned.",
    },
    9: {
      name: "Yusuf Amini",
      review:
        "Very informative and wonderfully paced. The examples were relatable, and the exercises were perfect for practicing the new skills.",
    },
    10: {
      name: "Brielle Foster",
      review:
        "I finally understand how data is cleaned, transformed, and interpreted. This course broke everything down so effectively.",
    },
    11: {
      name: "Gwen Morris",
      review:
        "A smooth and enjoyable introduction to Data Science. I appreciated how the instructor explained complex topics using simple examples.",
    },
    12: {
      name: "Odin Stewart",
      review:
        "The course was interactive and practical. Working with real-world datasets helped me gain a stronger understanding of data manipulation.",
    },
    13: {
      name: "Harper D’Souza",
      review:
        "Loved this course! The explanations of visualization tools and basic statistics were incredibly clear. I now have a solid base to continue learning.",
    },
    14: {
      name: "Zachary Hunt",
      review:
        "A great starting point for beginners. The lessons were simple, clear, and full of helpful examples. Truly a well-structured course.",
    },
    15: {
      name: "Leila Hassani",
      review:
        "This course gave me confidence in understanding data patterns and drawing insights. Perfect introduction for non-technical learners.",
    },
    16: {
      name: "Maximilian Ortiz",
      review:
        "The course was very hands-on and easy to follow. It helped me understand how to approach and analyze datasets in a structured way.",
    },
    17: {
      name: "Elena Varga",
      review:
        "I enjoyed every part of this course! The instructor explained concepts like mean, median, variance, and visualizations very clearly.",
    },
    18: {
      name: "Devin Marshall",
      review:
        "A very practical course. I learned how to prepare data properly, which is something I always struggled with. The examples were great!",
    },
    19: {
      name: "Aria Fernandez",
      review:
        "This course truly simplified the basics of Data Science. I liked the visual learning approach and real-world examples.",
    },
    20: {
      name: "Tomasz Zielinski",
      review:
        "The lessons were detailed but never overwhelming. The pace was perfect for someone like me who is new to data analysis.",
    },
    21: {
      name: "Kyra Benton",
      review:
        "A fantastic introduction! I especially loved the section on understanding trends and patterns within data. Very educational.",
    },
    22: {
      name: "Julien Ross",
      review:
        "Explained in a very friendly way. Learned a lot about basic analytics and how to interpret charts. Great course overall.",
    },
    23: {
      name: "Nadia Sharif",
      review:
        "Before this course, Data Science felt intimidating, but now I actually enjoy working with data. The explanations were clear and helpful.",
    },
    24: {
      name: "Roman Delgado",
      review:
        "The content was well-organized and beginner-friendly. I enjoyed doing the coding tasks and seeing real outputs.",
    },
    25: {
      name: "Hailey Monroe",
      review:
        "This course made Data Science feel fun and easy. Thanks to the simple teaching style, I understand the fundamentals much better now.",
    },
  },
  modules: {
    "Data Processing & Visualization": [
      "High-performance numerical computing with NumPy.",
      "Data ingestion, transformation, and aggregation using Pandas.",
      "Exploratory and analytical visualizations with Matplotlib.",
    ],
    "Foundations of Machine Learning": [
      "Conceptual framework of machine learning systems.",
      "Lifecycle and Types of Machine Learning.",
      "Problem formulation: classification, regression, clustering etc.",
      "ML Model Deployment Strategies and Performance Evaluation.",
    ],
    "Model Development & Evaluation": [
      "Implementing Baseline Algorithms: Linear models, Decision Trees, KNN, etc.",
      "Learning paradigms: supervised, unsupervised, and semi-supervised methods.",
      "Understanding Scikit-learn's API architecture and modular design.",
      "Data partitioning: train/test split, cross-validation strategies.",
    ],
    "Applied Predictive Modeling": [
      "Feature engineering and dimensionality handling.",
      "Hyperparameter tuning and performance optimization.",
      "Mitigation strategies for overfitting and underfitting.",
      "Understanding bias-variance, trade-off and model generation.",
    ],
    "Real-World Impact & Capstone Journey": [
      "Explore domain-specific applications in business intelligence, digital ecosystems, healthcare, etc.",
      "Work on an end-to-end capstone project simulating an industry problem.",
      "Build a project portfolio showcasing your data science capabilities.",
    ],
  },
};
